export default __webpack_public_path__ + "static/img-june-fund-4b978dbbe534f184d9cc31e3a3bbd6ca.png";